import React, { Component } from 'react';

class SearchPreferences extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
            tempPreferences: { ...props.preferences }
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.preferences !== this.props.preferences) {
            this.setState({ tempPreferences: { ...this.props.preferences } });
        }
    }

    handleCategoryToggle = (category) => {
        const { tempPreferences } = this.state;
        const categories = [...tempPreferences.categories];
        const index = categories.indexOf(category);
        
        if (index > -1) {
            categories.splice(index, 1);
        } else {
            categories.push(category);
        }
        
        this.setState({
            tempPreferences: {
                ...tempPreferences,
                categories
            }
        });
    };

    handleChange = (field, value) => {
        this.setState({
            tempPreferences: {
                ...this.state.tempPreferences,
                [field]: value
            }
        });
    };

    handleSave = () => {
        this.props.onUpdate(this.state.tempPreferences);
        this.setState({ isEditing: false });
    };

    handleCancel = () => {
        this.setState({
            isEditing: false,
            tempPreferences: { ...this.props.preferences }
        });
    };

    render() {
        const { isEditing, tempPreferences } = this.state;
        const { preferences } = this.props;

        const availableCategories = [
            'Amateur', 'Asian', 'Big Tits', 'Blonde', 'Brunette', 
            'Ebony', 'Latina', 'MILF', 'Teen', 'Anal',
            'Blowjob', 'Creampie', 'Hardcore', 'Lesbian', 'Threesome'
        ];

        const displayPreferences = isEditing ? tempPreferences : preferences;

        return (
            <div className="search-preferences">
                <div className="preferences-header">
                    {!isEditing ? (
                        <button 
                            className="edit-preferences-btn"
                            onClick={() => this.setState({ isEditing: true })}
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                            </svg>
                            Edit Preferences
                        </button>
                    ) : (
                        <div className="edit-actions">
                            <button 
                                className="save-btn"
                                onClick={this.handleSave}
                            >
                                Save Changes
                            </button>
                            <button 
                                className="cancel-btn"
                                onClick={this.handleCancel}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>

                <div className="preference-section">
                    <h3>Favorite Categories</h3>
                    <div className="categories-grid">
                        {availableCategories.map(category => (
                            <label 
                                key={category}
                                className={`category-chip ${displayPreferences.categories.includes(category) ? 'selected' : ''}`}
                            >
                                <input
                                    type="checkbox"
                                    checked={displayPreferences.categories.includes(category)}
                                    onChange={() => isEditing && this.handleCategoryToggle(category)}
                                    disabled={!isEditing}
                                />
                                {category}
                            </label>
                        ))}
                    </div>
                </div>

                <div className="preference-section">
                    <h3>Default Filters</h3>
                    <div className="filters-grid">
                        <div className="filter-group">
                            <label>Duration</label>
                            <select 
                                value={displayPreferences.duration}
                                onChange={(e) => this.handleChange('duration', e.target.value)}
                                disabled={!isEditing}
                                className="filter-select"
                            >
                                <option value="all">All Durations</option>
                                <option value="short">0-10 min</option>
                                <option value="medium">10-20 min</option>
                                <option value="long">20+ min</option>
                            </select>
                        </div>

                        <div className="filter-group">
                            <label>Quality</label>
                            <select 
                                value={displayPreferences.quality}
                                onChange={(e) => this.handleChange('quality', e.target.value)}
                                disabled={!isEditing}
                                className="filter-select"
                            >
                                <option value="all">All Qualities</option>
                                <option value="hd">HD Only</option>
                                <option value="4k">4K Only</option>
                            </select>
                        </div>

                        <div className="filter-group">
                            <label>Sort By</label>
                            <select 
                                value={displayPreferences.sort}
                                onChange={(e) => this.handleChange('sort', e.target.value)}
                                disabled={!isEditing}
                                className="filter-select"
                            >
                                <option value="recent">Most Recent</option>
                                <option value="views">Most Viewed</option>
                                <option value="rating">Top Rated</option>
                                <option value="duration">Longest</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="preference-info">
                    <p>Your search preferences will be applied automatically when you search for videos.</p>
                </div>
            </div>
        );
    }
}

export default SearchPreferences;